/* global window document */

import $ from 'jquery';
import debounce from 'lodash/debounce';
import assign from 'lodash/assign';
// import URLQueryBuilder from 'url-query-builder';


import './FilterContent.scss';
import template from './FilterContent.vhtml';

const currentLanguage = window.siteData.language || 'da';
const itemsPerPage = 6;

export default {
	name: 'FilterContent',
	template: template,
	props: {
		'itemType': {
			type: String,
			default: 'images',
		},
		'taxonomyFilters': {
			type: Array,
			default: () => [],
		},
		'search': {
			type: String,
			default: '',
		},
	},
	data: () => ({
		items: [],
		page: 1,
		isLoading: false,
		isChanging: false,
		showMore: true,
	}),
	watch: {
		search() {
			this.reload();
		},
		taxonomyFilters() {
			this.reload();
		},
	},
	methods: {

		addItems(items, overwrite = false) {
			// We use the +one method to determine if there are more items to show
			if (items.length > itemsPerPage) {
				this.showMore = true;
				items = items.slice(0, itemsPerPage);
			} else {
				this.showMore = false;
			}
			if (overwrite) {
				this.items = items;
			} else {
				this.items = [...this.items, ...items];
			}
		},
		fetchMore() {
			this.isLoading = true;
			getItems(this.itemType, this.search, this.taxonomyFilters, this.page * itemsPerPage)
				.then(items => {
					if (items) {
						if (typeof items != 'object') {
							items = JSON.parse(items)
						}
						this.page = this.page + 1;
						this.addItems(items);
					}
				})
				.always(() => this.isLoading = false);
		},
		reload: debounce(function () {
			this.isChanging = true;
			this.updateUrl();
			getItems(this.itemType, this.search, this.taxonomyFilters)
				.then(items => {
					if (items) {
						if (typeof items != 'object') {
							items = JSON.parse(items)
						}
						this.page = 1;
						this.addItems(items, true);
					}
				})
				.always(() => this.isChanging = false);
		}, 500),
		updateUrl() {
			// const urlParams = assign({}, { search: this.search }, { taxonomies: this.taxonomyFilters.join(',') });
			// const q = new URLQueryBuilder(document.location.href, urlParams);
			// window.history.replaceState(null, null, q.get());

			window.history.replaceState(null, null, `${location.pathname}?search=${this.search}`)
			if (this.search.length === 0) {
				window.history.replaceState(null, null, `${location.pathname}`)
			}
		},
	},
	mounted() {
		this.reload();
	}
};

/**
 * Gets items of different post types from WP REST API
 *
 * @param {string} itemType
 * @param {number} [offset=0]
 * @returns {JQueryPromise<any>}
 */
function getItems(itemType, search = null, taxonomyFilters, offset = 0) {
	const params = {
		'per_page': itemsPerPage + 1,
		'offset': offset,
		'type': itemType,
		'lang': currentLanguage,
		's': search,
		'taxonomies': taxonomyFilters.join(','),
		'_': '1.5',
	};

	return $.get(`/wp-json/be/v1/press-items`, params);
}
